var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67.476,
    height: 66.894,
    viewBox: "0 0 67.476 66.894",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1.466,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a6192e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1213b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cup-star-svgrepo-com",
    transform: "translate(-0.5 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9788",
    "data-name": "Trazado 9788",
    d: "M17.64,28.927l9.08-5.045c2.426-1.348,3.638-2.021,4.306-3.156s.668-2.523.668-5.3v-.234c0-3.364,0-5.047-.913-6.313s-2.508-1.8-5.7-2.862L22.023,5l-.054.273c-.015.61-.042,1.275-.071,2C21.614,14.448,20.683,22.533,17.64,28.927Z",
    transform: "translate(34.781 6.671)",
    fill: "none",
    stroke: "#e1213b",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9789",
    "data-name": "Trazado 9789",
    d: "M11.8,7.278c.285,7.171,1.216,15.256,4.259,21.65L6.974,23.882c-2.426-1.348-3.638-2.021-4.306-3.156S2,18.2,2,15.429v-.234c0-3.364,0-5.047.913-6.313s2.509-1.8,5.7-2.862L11.671,5l.056.28C11.742,5.888,11.768,6.55,11.8,7.278Z",
    transform: "translate(0 6.671)",
    fill: "none",
    stroke: "#e1213b",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9790",
    "data-name": "Trazado 9790",
    d: "M5.25,23.668A2.418,2.418,0,0,1,7.668,21.25H46.353a2.418,2.418,0,1,1,0,4.836H7.668A2.418,2.418,0,0,1,5.25,23.668Z",
    transform: "translate(7.227 42.808)",
    fill: "#e1213b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9791",
    "data-name": "Trazado 9791",
    d: "M30.836,26.929H8.543L9.5,21.288A3.224,3.224,0,0,1,12.661,18.7H26.718a3.223,3.223,0,0,1,3.161,2.592Z",
    transform: "translate(14.55 37.129)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9792",
    "data-name": "Trazado 9792",
    d: "M13.668,16.077q-1.255,0-2.418-.111v8.8h4.836v-8.8Q14.922,16.076,13.668,16.077Z",
    transform: "translate(20.57 31.057)",
    fill: "#e1213b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9787",
    "data-name": "Trazado 9787",
    d: "M27.538,47.133C8.969,47.133,5.68,28.627,5.1,13.949c-.162-4.083-.243-6.124,1.29-8.013s3.369-2.2,7.04-2.818A85.025,85.025,0,0,1,27.538,2,85.022,85.022,0,0,1,41.649,3.118c3.671.619,5.507.929,7.04,2.818s1.453,3.93,1.29,8.013C49.4,28.627,46.107,47.133,27.538,47.133Z",
    transform: "translate(6.702)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9793",
    "data-name": "Trazado 9793",
    d: "M15.918,8.3C17.143,6.1,17.756,5,18.671,5S20.2,6.1,21.425,8.3l.317.569a3.543,3.543,0,0,0,.793,1.143,3.306,3.306,0,0,0,1.285.435l.615.139c2.379.538,3.568.807,3.851,1.717s-.528,1.858-2.15,3.755l-.42.491a3.565,3.565,0,0,0-.795,1.142,3.718,3.718,0,0,0,0,1.412l.064.655c.245,2.53.368,3.8-.373,4.358s-1.855.05-4.082-.976l-.576-.265a3.3,3.3,0,0,0-1.285-.437,3.3,3.3,0,0,0-1.285.437l-.576.265c-2.227,1.025-3.341,1.538-4.082.976s-.618-1.828-.373-4.358l.064-.655a3.718,3.718,0,0,0,0-1.412,3.563,3.563,0,0,0-.8-1.142l-.42-.491c-1.622-1.9-2.433-2.845-2.15-3.755s1.472-1.179,3.851-1.717l.615-.139a3.306,3.306,0,0,0,1.285-.435A3.543,3.543,0,0,0,15.6,8.865Z",
    transform: "translate(15.566 6.672)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.e849eea3199f4a1f9ebb0b4463ded5ca.svg";
export { ForwardRef as ReactComponent };